import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

//Context
import { useAuth } from '../../../context/auth';

//Helpers
import mascaras from '../../../helpers/mascaras';
import { showMessage } from '../../../helpers/message';

// Api
import dashboard_api from '../../../api/dashboard_api';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Componentes
import FichaGerador from '../../../views/Cadastros/Geradores/FichaGerador';

export default function GeradoresAguardandoAtivacaoContratoPGRS() {
    const { setLoading, session, setupVariavel } = useAuth();

    const [listGeradoresAguardandoAtivacacaoContratoPGRS, setListGeradoresAguardandoAtivacacaoContratoPGRS] = useState([]);

    const [ficha, setFicha] = useState(null);

    //Cabeçalhos da tabela de listagem de geradores
    const headersTabela = [
        { value: "CNPJ", objectValue: "cnpj", align: "left" },
        { value: "Fantasia", objectValue: "fantasia", align: "left", },
        { value: "Status", objectValue: "status", align: "left" },
        { value: "Situação Contrato", objectValue: "situacaoContrato", align: "left" },
        { value: "Modalidade de Coleta", objectValue: "modalidadeColeta", align: "left" },
        { value: "Endereço", objectValue: "endereco", align: "left" },
        { value: "Frequência", objectValue: "frequencia", align: "left" },
        { value: "Quantidade Estimada", objectValue: "quantidadeEstimada", align: "left" },
    ];

    //Variavel para navegação entre telas
    const navigate = useNavigate();

    //Ações  da tabela
    const actions = [actionsTable.visualizar((item) => setFicha(item.id))];

    function loadGeradoresAguardandoAtivacaoContratoPGRS() {
        setLoading(true)
        dashboard_api.GeradoresAguardandoAtivacaoContratoPGRS().then(response => {
            response.data = response.data.map(item => {
                item.cnpj = mascaras.cpfcnpjMask(item.cnpj);
                item.quantidadeEstimada = mascaras.floatMask(item.quantidadeEstimada)
                return item;
            })
            setListGeradoresAguardandoAtivacacaoContratoPGRS(response.data);
        }).catch(e => {
            showMessage("Erro", e.message, "error", null);
        }).finally(() => setLoading(false));
    }

    useEffect(() => {
        loadGeradoresAguardandoAtivacaoContratoPGRS()
    }, []);

    if (!!ficha) {
        return <FichaGerador
            btnVoltar={() => {
                setFicha(null)
                loadGeradoresAguardandoAtivacaoContratoPGRS()
            }}
            id={ficha}
            integracaoCadastros={setupVariavel?.integracaoCadastros}
            permissao={session?.acesso?.sigla == "TR" ? "Editar" : ""}
        />
    }

    return (
        <MainCard
            btnVoltarInTop={() => navigate(-1)}
            noCard
        >
            <div className={`w-100 `}>
                <div className='mt-4'>
                    <TabelaListagem
                        headers={headersTabela}
                        items={listGeradoresAguardandoAtivacacaoContratoPGRS}
                        actions={actions}
                        title="Lista de geradores aguardando ativação contrato PGRS"
                        options={{ print: false, search: true, pagination: true }}
                    />
                </div>
            </div>
        </MainCard>
    )
}
